/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Directory_LeadInputs */

const en_features_directory_lead = /** @type {(inputs: Features_Directory_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clients nearby find you on their own.`)
};

const pl_features_directory_lead = /** @type {(inputs: Features_Directory_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klienci z okolicy znajdą Cię sami.`)
};

/**
* | output |
* | --- |
* | "Clients nearby find you on their own." |
*
* @param {Features_Directory_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_directory_lead = /** @type {((inputs?: Features_Directory_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Directory_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_directory_lead(inputs)
	return en_features_directory_lead(inputs)
});